import { all, fork } from 'redux-saga/effects';

import accountRequestSaga from 'app/lib/account/saga';
import { signalRSaga } from 'app/lib/signalr';
import { changeSiteConfigSaga, siteConfigsSaga } from 'app/lib/site-configs/saga';

import betSlipSaga from '../../modules/BetSlip/saga';
import myStakesCashoutSaga from '../../modules/MyStakes/cashoutSaga';
import activeStakesSaga from '../../modules/MyStakes/saga/activeStakesSaga';
import displayModalSaga from '../../modules/SigningNew/displayModalSaga';

// import betPriceRandomizerSaga from './betPriceRandomizer';

export default function* rootSaga() {
  yield all([
    fork(siteConfigsSaga),
    fork(changeSiteConfigSaga),
    fork(accountRequestSaga),
    fork(signalRSaga),
    fork(betSlipSaga),
    fork(activeStakesSaga),
    fork(myStakesCashoutSaga),
    fork(displayModalSaga),
    // fork(betPriceRandomizerSaga),
  ]);
}
